/**
 * FlowBookingPage - Redirects to services-grid.html with flow parameters
 * 
 * Handles URLs like /book/{orgSlug}/{flowSlug}
 * Redirects to the services-grid.html widget which handles the actual booking UI
 */
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const FlowBookingPage = () => {
  const { orgSlug, flowSlug } = useParams();
  
  useEffect(() => {
    if (orgSlug && flowSlug) {
      // Redirect to services-grid.html with the flow and org parameters
      const widgetUrl = `/services-grid.html?org=${orgSlug}&flow=${flowSlug}`;
      window.location.href = widgetUrl;
    }
  }, [orgSlug, flowSlug]);
  
  // Show loading state while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading booking widget...</p>
      </div>
    </div>
  );
};

export default FlowBookingPage;
